import React from 'react';

import { IconTypes } from '@eika/icon';
import { Label, LabelTypes } from '@eika/label';

import { ConsentAssignmentStatus } from '../../../interfaces/ConsentAssignmentTypes';
import { useTranslation } from '../../../translations';
import { formatTranslation } from '../../../translations/useTranslation';

import './ConsentAssignmentLabels.scss';

interface ConsentAssignmentLabelsProps {
    status: string;
    deadlineIsToday: boolean;
    deadline: string;
}

const ConsentAssignmentLabels = ({ status, deadlineIsToday, deadline }: ConsentAssignmentLabelsProps) => {
    const { taskStatus } = useTranslation();
    switch (status) {
        case ConsentAssignmentStatus.ACCEPTED:
            return (
                <Label
                    text={taskStatus.consentAssignmentSigned}
                    type={LabelTypes.SUCCESS_SMALL}
                    icon={IconTypes.USP_CHECKMARK_24}
                />
            );
        case ConsentAssignmentStatus.EXPIRED:
            return (
                <Label text={taskStatus.deadlinePassed} type={LabelTypes.ERROR_SMALL} icon={IconTypes.UTROPSTEGN_24} />
            );
        case ConsentAssignmentStatus.REJECTED:
            return <Label text={taskStatus.rejected} type={LabelTypes.ERROR_SMALL} icon={IconTypes.UTROPSTEGN_24} />;
        default:
            return (
                <>
                    <Label
                        text={
                            deadlineIsToday
                                ? taskStatus.deadlineToday
                                : formatTranslation(taskStatus.deadline, deadline)
                        }
                        type={deadlineIsToday ? LabelTypes.INVERTED_SMALL : LabelTypes.WARNING_SMALL}
                    />
                    <Label text={taskStatus.requiresAction} type={LabelTypes.ATTENTION_SMALL} />
                </>
            );
    }
};

export default ({ status, deadlineIsToday, deadline }: ConsentAssignmentLabelsProps) => (
    <div className="consent-assignment-labels">
        <ConsentAssignmentLabels status={status} deadline={deadline} deadlineIsToday={deadlineIsToday} />
    </div>
);
